import { endOfDay, startOfDay, subDays } from 'date-fns';
import { initStore } from '../../../common';
import { actions } from './actions';

export const dashboardStore = (): void => {
	const initialState = {
		slice: 'DASHBOARD',
		summary: {},
		devices: {},
		categories: {},
		statistics: {},
		big_wins: [],
		providers: {},
		dashboardLoading: false,
		filters: [
			{
				name: 'start_date',
				value: startOfDay(subDays(new Date(), 1)),
			},
			{
				name: 'end_date',
				value: endOfDay(subDays(new Date(), 1)),
			},
		],
		globalErrors: [],
		globalSuccess: '',
	};

	initStore(actions, initialState);
};
